import React from 'react';
import './DataProtection.css';
import { FaShieldAlt } from 'react-icons/fa';

const DataProtection = () => {
  return (
    <section className="data-protection" id="data-protection">
      <div className="data-protection-container">
        <div className="data-protection-header">
          <div className="data-protection-title-row">
            <h2 className="data-protection-title">Data Protection Standards</h2>
          </div>
          <p className="data-protection-subtitle">
            Fully HIPAA compliant, ensuring your data remains safe.
          </p>
        </div>
        
        <div className="protection-features">
          <div className="protection-feature">
            <h3 className="feature-title">Fully HIPAA Compliant</h3>
            <p className="feature-description">
              We use best-in-class security practices and have HIPAA agreements with all partners.
            </p>
          </div>
          
          <div className="protection-feature">
            <h3 className="feature-title">24/7 Monitoring</h3>
            <p className="feature-description">
              Our systems are carefully monitored 24/7.
            </p>
          </div>
          
          <div className="protection-feature">
            <h3 className="feature-title">Controlled Data Access</h3>
            <p className="feature-description">
              We adhere to the principles of least privilege and implement role-based permissions for accessing data.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DataProtection;
